import {
  createApi,
  FetchArgs,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { API_URL_BSRM } from "../../constants/constants";
import { removeHash } from "../../utils/hash";

export const bsrmAppServiceApi = createApi({
  reducerPath: "bsrmAppServiceApi",
  baseQuery: async (args: string | FetchArgs, api, extraOptions) => {
    const rawBaseQuery = fetchBaseQuery({
      baseUrl: API_URL_BSRM,
      prepareHeaders: (headers, { getState }) => {
        const token = (getState() as any).auth?.access_token;

        if (token) headers.set("Authorization", `Bearer ${token}`);

        // if (token)
        //   headers.set(
        //     "Authorization",
        //     `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZXJ2aWNlTmFtZSI6InJlcG9ydF9zZXJ2aWNlIiwiaWF0IjoxNzM3NTMzMDA0LCJleHAiOjE3NDAxMjUwMDR9.vfJP9xigE4XxYPm0RUQDEB2ja6MAuuS6pqCNu2YOFBc`
        //   );
        // headers.set("ServiceName", "report_service");
        headers.set("ngrok-skip-browser-warning", "true");

        return headers;
      },
    });

    const asObj: FetchArgs =
      typeof args === "string" ? { url: args } : { ...args };

    const productType = localStorage.getItem("product-type");
    const productId = productType ? removeHash(JSON.parse(productType)) : null;

    const dynamic = localStorage.getItem("dynamic");
    const dynamicData = dynamic ? JSON.parse(dynamic) : null;

    const defaultParams = {
      productId,
      // supplierKeyword:
      //   removeHash(dynamicData?.dynamicKeyword?.split(" ")?.join("+")) || null,
      // supplierId:
      //   removeHash(dynamicData?.dynamicId?.split(" ")?.join("+")) || null,
    };

    asObj.params = { ...defaultParams, ...(asObj.params ?? {}) };

    return rawBaseQuery(asObj, api, extraOptions);
  },

  endpoints: () => ({}),
});
